import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectHeatpumpFlowChartComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.HeatpumpFlowChartComponent
);

export const selectHeatpumpDailyTelemetryComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.HeatpumpDailyTelemetryComponent
);

export const selectHeatpumpEnergyAggregationComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.HeatpumpEnergyAggregationComponent
);

export const selectHeatpumpFlowChartData = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpFlowChartComponent,
  (systemState, heatpumpFlowChartComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }
    const instanceBlock = heatpumpFlowChartComponent?.[instanceId];
    if (!instanceBlock) {
      return null;
    }
    return instanceBlock[selectedSystem]?.[heatpumpId]?.heatpumpData ?? null;
  }
);

export const selectHeatpumpDailyTelemetryData = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpDailyTelemetryComponent,
  (systemState, heatpumpDailyTelemetryComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = heatpumpDailyTelemetryComponent?.[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.[heatpumpId]?.heatpumpData ?? null;
  }
);

export const selectHeatpumpEnergyAggregationMonthlyData = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpEnergyAggregationComponent,
  (systemState, heatpumpEnergyAggregationComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = heatpumpEnergyAggregationComponent?.[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.[heatpumpId]?.monthlyData ?? null;
  }
);

export const selectHeatpumpEnergyAggregationYearlyData = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpEnergyAggregationComponent,
  (systemState, heatpumpEnergyAggregationComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = heatpumpEnergyAggregationComponent?.[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.[heatpumpId]?.yearlyData ?? null;
  }
);

export const selectHeatpumpEnergyAggregationMonthlyState = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpEnergyAggregationComponent,
  (systemState, heatpumpEnergyAggregationComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return 'pending';
    }

    const instanceBlock = heatpumpEnergyAggregationComponent?.[instanceId];
    if (!instanceBlock) {
      return 'pending';
    }

    return instanceBlock[selectedSystem]?.[heatpumpId]?.monthlyState || 'pending';
  }
);

export const selectHeatpumpEnergyAggregationYearlyState = (
  instanceId: string,
  heatpumpId: string,
) => createSelector(
  selectSystemState,
  selectHeatpumpEnergyAggregationComponent,
  (systemState, heatpumpEnergyAggregationComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return 'pending';
    }

    const instanceBlock = heatpumpEnergyAggregationComponent?.[instanceId];
    if (!instanceBlock) {
      return 'pending';
    }

    return instanceBlock[selectedSystem]?.[heatpumpId]?.yearlyState || 'pending';
  }
);
